import {
  buildCheckoutIframeSearch,
  cleanCheckoutReturnParamsFromCurrentUrl,
  isCheckoutReturnConsumedMessage,
} from './iframe-return-bridge';

// Widget loader — embedded on third-party sites via a single <script> tag
// Builds to dist/embed.js as an IIFE (<5KB target)
// Usage: <script src="https://widget.aloragiving.com/embed.js"
//                data-widget-id="wgt_xxx"
//                data-api-base-url="https://api.aloragiving.com"></script>

(function () {
  const script = document.currentScript as HTMLScriptElement | null;
  if (!script) return;

  const widgetId = script.dataset['widgetId'] ?? '';
  const apiBaseUrl =
    script.dataset['apiBaseUrl'] ??
    (typeof window !== 'undefined' &&
      (window as unknown as Record<string, string>)['__DONATION_KIOSK_API_URL__']) ??
    (typeof window !== 'undefined' ? window.location.origin : '');

  if (!widgetId) {
    console.warn('[DonationWidget] Missing data-widget-id attribute.');
    return;
  }

  // CHG-3240 — pass the host (embedding) page URL into the checkout iframe so
  // the redirect-provider donor-back webhook can return the donor here, not to
  // the API-hosted form URL (which is what window.location.href is INSIDE the
  // iframe). See CONT-PUBLIC-URL-001 §3 "Gateway donor-back redirect".
  const parentUrl =
    typeof window !== 'undefined' ? window.location.href.split('#')[0] : '';
  const src =
    `${apiBaseUrl.replace(/\/$/, '')}/api/v1/public/widget/${encodeURIComponent(widgetId)}/form` +
    buildCheckoutIframeSearch(
      parentUrl,
      typeof window !== 'undefined' ? window.location.search : '',
    );

  const iframe = document.createElement('iframe');
  iframe.src = src;
  iframe.title = 'Donation Widget';
  iframe.setAttribute('loading', 'lazy');
  iframe.setAttribute('allow', 'payment');
  iframe.setAttribute('scrolling', 'no');
  iframe.style.cssText = [
    'border: 0',
    'width: 100%',
    'min-height: 600px',
    'overflow: hidden',
    'display: block',
  ].join('; ');

  window.addEventListener('message', (e: MessageEvent) => {
    if (e.source !== iframe.contentWindow) return;
    const data = e.data as { type?: string; height?: number; url?: string };
    if ((data?.type === 'ag-widget-resize' || data?.type === 'resize') && typeof data.height === 'number') {
      iframe.style.height = `${data.height}px`;
      iframe.style.minHeight = `${data.height}px`;
    }
    if (isCheckoutReturnConsumedMessage(data)) {
      cleanCheckoutReturnParamsFromCurrentUrl();
    }
    // #258 — break redirect-based payment gateways out of the cross-origin iframe.
    // The checkout posts { type: 'ag-widget-redirect', url } when it detects it is
    // framed in a cross-origin context; the loader (running in the top page) does the
    // top-level navigation so the gateway is not loaded inside an iframe.
    if (data?.type === 'ag-widget-redirect' && typeof data.url === 'string' && /^https?:\/\//i.test(data.url)) {
      window.location.assign(data.url);
    }
  });

  script.parentNode?.insertBefore(iframe, script.nextSibling);
})();
